import Vue from "vue";
import Vuex from "vuex";

import Header from "../modules/header.module";
import Home from "../modules/home.module";
import CarDrive from "../modules/car-drive.module";
import Safety from "../modules/safety.module";
import DriveControl from "../modules/drive-control.module";
import Audio from "../modules/audio.module";
import Interior from "../modules/interior.module";
import Color from "../modules/color.module";
import CarSlider from "../modules/car-slider.module";
import Form from "../modules/form.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Header,
    Home,
    CarDrive,
    Safety,
    DriveControl,
    Audio,
    Interior,
    Color,
    CarSlider,
    Form
  }
});
